import { AfterViewInit, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { NamedTemplateDirective } from 'src/app/directives/named-template.directive';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { DynamicFormModel } from 'src/app/models/service/dynamic-form-model';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';

@Component({
    selector: 'app-questionnaire-summary',
    templateUrl: './questionnaire-summary.component.html',
    styleUrls: ['./questionnaire-summary.component.scss'],
    standalone: false
})
export class QuestionnaireSummaryComponent implements AfterViewInit {

  @Input() dynamicFormModel: DynamicFormModel;
  @Input() sandbox: boolean;
  @ViewChildren(NamedTemplateDirective) templates: QueryList<NamedTemplateDirective>;
  templatesMap: KeyValueMap<string, NamedTemplateDirective>;
  InstallationSchemaPropertyType = InstallationSchemaPropertyType;
  showTopLevelTitle = true;

  constructor() { }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.dynamicFormModel.property.properties.forEach((element: any) => {
        let currentValue: any = this.dynamicFormModel.formGroup.controls[this.dynamicFormModel.property.name]?.get(element.name)?.value;
        if (element.updatedValue && element.type === 'string' && element['x-edit'] === 'append') {
          element?.updatedValue?.split(",")?.map(item => item?.trim()).forEach(value => {
            if (!(currentValue?.split(',')?.map(item => item?.trim())?.includes(value))) {
              currentValue = value + ',' + currentValue;
            }
          })
          element.displayValue = currentValue;
        }
      });
      this.templatesMap = this.templates.reduce((accumulator, currentValue) => {
        accumulator[currentValue.appNamedTemplate] = currentValue.template;
        return accumulator;
      }, {});
    });
  }

}
